var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location-map overflow-hidden"},[_c('google-maps-find-location',{attrs:{"address":_vm.addressForMap,"initialPos":_vm.initialPos,"selectable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }